import { useParams, useRoutes } from "react-router-dom";

import CredentialPage from "./credential";
import EntitlementPage from "./entitlement";
import DeploymentPage from "./index";
import UsagePage from "./usage";

export default () =>
  useRoutes([
    { path: "/:deploymentId/usage/api/:api", element: <WithParameters component={UsagePage}/> },
    { path: "/:deploymentId/usage/month/:ymd", element: <WithParameters component={UsagePage}/> },
    { path: "/:deploymentId/usage", element: <WithParameters component={UsagePage}/> },
    { path: "/:deploymentId/entitlement/:entitlementId", element: <WithParameters component={EntitlementPage}/> },
    { path: "/:deploymentId/entitlement", element: <WithParameters component={EntitlementPage}/> },
    { path: "/:deploymentId/credential", element: <WithParameters component={CredentialPage}/> },
    { path: "/:deploymentId", element: <WithParameters component={DeploymentPage}/> },
    { path: "/", element: <WithParameters component={DeploymentPage}/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  return <Comp {...parameters} />;
}
